import { useSyncExternalStore } from "react";
import { formatMoney } from "@/lib/utils/format";

const KEY = "hrms.earnings.masked";
const MASK = "₹ ••••";

// A per-viewer convenience: hide amounts on screen (shoulder surfing, screen
// share). Browser storage can be blocked, so it falls back to memory.
let memory = false;
const listeners = new Set<() => void>();

function read(): boolean {
  try {
    const stored = window.localStorage.getItem(KEY);
    return stored === null ? memory : stored === "1";
  } catch {
    return memory;
  }
}

function subscribe(fn: () => void) {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

export function setAmountsMasked(next: boolean) {
  memory = next;
  try {
    window.localStorage.setItem(KEY, next ? "1" : "0");
  } catch {
    /* kept in memory */
  }
  listeners.forEach((fn) => fn());
}

/** Whether the employee has chosen to hide amounts, shared by every earnings
 * card on the page, and a formatter that respects it. */
export function useAmountPrivacy() {
  const masked = useSyncExternalStore(subscribe, read, () => false);
  return {
    masked,
    toggle: () => setAmountsMasked(!masked),
    money: (amount: number | string | null | undefined) => (masked ? MASK : formatMoney(amount)),
  };
}
